export default __webpack_public_path__ + "static/media/whitepaper.eb949cfe.pdf";